import React from 'react';

const LogoWestlaw = ({ className = "w-12 h-12" }) => (
  <svg className={className} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="48" height="48" rx="12" fill="#B91C1C"/>
    <path d="M14 16C14 14.8954 14.8954 14 16 14H32C33.1046 14 34 14.8954 34 16V32C34 33.1046 33.1046 34 32 34H16C14.8954 34 14 33.1046 14 32V16Z" fill="white"/>
    <path d="M18 18H30V20H18V18Z" fill="#B91C1C"/>
    <path d="M18 22H30V24H18V22Z" fill="#B91C1C"/>
    <path d="M18 26H30V28H18V26Z" fill="#B91C1C"/>
    <path d="M18 30H24V32H18V30Z" fill="#B91C1C"/>
  </svg>
);

export default LogoWestlaw;
